import React from 'react';
import { UX2, constants } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';
import { mapContextToProps } from '../../OlsShopContext';

const modalStyle = {
  header: {
    textAlign: 'center',
    paddingBottom: 'medium'
  },
  outer: {
    display: 'flex',
    textAlign: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%'
  },
  inner: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  }
};

export class Modal extends React.Component {
  componentDidMount = () => {
    this._overflowValue = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    if (this.mobilePreviewContainer) {
      this._mobileOverflowValue = this.mobilePreviewContainer.style.overflow;
      this.mobilePreviewContainer.style.overflow = 'hidden';
    }
  };

  componentWillUnmount = () => {
    document.body.style.overflow = this._overflowValue;

    if (this.mobilePreviewContainer) {
      this.mobilePreviewContainer.style.overflow = this._mobileOverflowValue;
    }
  };

  get mobilePreviewContainer() {
    return document.querySelector('#view-mobile #render-container');
  }

  get isPreview() {
    return this.props.renderMode === constants.renderModes.PREVIEW;
  }

  get preventShrink() {
    // Case 1: we don't want to prevent shrinking for published sites
    if (!this.isPreview) return false;
    // Case 2: in Preview mode, we want to prevent shrinking when the user is
    // on desktop sized device and clicks on the modal from either desktop or mobile view
    if (this.props.viewDevice !== 'MOBILE_RENDER_DEVICE') return true;

    // Case 3: in Preview mode on a mobile device, we do not want to prevent shrink
    return !this.mobilePreviewContainer;
  }

  render() {
    const { Block } = UX2.Element;
    return (
      <UX2.Component.Modal
        onClose={ this.props.closeModal }
        preventShrink={ this.preventShrink }
        closeOnClickOutside={ this.props.closeOnClickOutside }
      >
        <Block style={ modalStyle.outer }>
          <Block style={ modalStyle.inner }>{ this.props.children }</Block>
        </Block>
      </UX2.Component.Modal>
    );
  }
}

Modal.propTypes = {
  closeModal: PropTypes.func,
  closeOnClickOutside: PropTypes.bool,
  renderMode: PropTypes.string,
  children: PropTypes.func,
  viewDevice: PropTypes.string
};

export default mapContextToProps(Modal, context => ({
  viewDevice: context.viewDevice
}));
